<template>
  <div id="app">
    <router-view />

    <b-modal id="modalLoading" ref="modalLoading" hide-header-close no-close-on-backdrop no-close-on-esc centered hide-footer size="sm">
      <div class="text-center">
        <div class="fa-3x">
          <i class="fas fa-circle-notch fa-spin"></i>
        </div>
        <p>
          <b>Carregando...</b>
        </p>
      </div>
    </b-modal>
  </div>
</template>
<script>
export default {
  computed: {
    isLoading() {
      return this.$store.getters.loading
    }
  },
  watch: {
    isLoading (value) {
      if (value) {
        this.$bvModal.show('modalLoading')
      } else {
        this.$bvModal.hide('modalLoading')
      }
    }
  }
}
</script>